var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeletePhotoEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDeletePhotoEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,-7.10542736e-15 C4.296,-7.10542736e-15 -9.23705556e-14,4.296 -9.23705556e-14,9.6 C-9.23705556e-14,14.904 4.296,19.2 9.6,19.2 C14.904,19.2 19.2,14.904 19.2,9.6 C19.2,4.296 14.904,-7.10542736e-15 9.6,-7.10542736e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6934064,9.6000216 L13.9735445,6.31987961 C14.2754852,6.01793861 14.2754852,5.52839677 13.9735445,5.22649895 C13.6716039,4.92455794 13.1821058,4.92455794 12.8801651,5.22649895 L9.5999838,8.50668413 L6.31980247,5.22645576 C6.01786182,4.92451475 5.52836375,4.92451475 5.22642309,5.22645576 C4.92452564,5.52839677 4.92452564,6.01793861 5.22642309,6.31983642 L8.50660442,9.5999784 L5.22642309,12.8801636 C4.92452564,13.1821046 4.92452564,13.6716464 5.22642309,13.9735442 C5.52836375,14.2754853 6.01786182,14.2754853 6.31980247,13.9735442 L9.5999838,10.6933591 L12.8801651,13.9735442 C13.1820626,14.2754853 13.6716039,14.2754853 13.9735445,13.9735442 C14.2754852,13.6716032 14.2754852,13.1821046 13.9735445,12.8801636 L10.6934064,9.6000216 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDeletePhotoEditProfile",
    transform: "translate(0.400000, 0.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FF0400",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeletePhotoEditProfile);
export default __webpack_public_path__ + "static/media/icDeletePhotoEditProfile.76e3b8341d90504f5f3ec1f2829b5e36.svg";
export { ForwardRef as ReactComponent };